var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.large ? 'container-md' : 'container']},[_c('div',{staticClass:"row",class:{ 'justify-content-center': !_vm.left }},[_c('div',{class:_vm.colClass},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }